import { SubscriptionProductType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nowy produkt',
  fields: {
    type: {
      label: 'Typ produktu',
      options: {
        [SubscriptionProductType.Plan]: 'Plan',
        [SubscriptionProductType.AddOn]: 'Dodatek',
        [SubscriptionProductType.GoogleAdsPlan]: 'Google Ads Plan',
      },
    },
    name: {
      label: 'Nazwa wewnętrzna',
      placeholder: 'Wprowadź wewnętrzną nazwę produktu',
    },
    public_name: {
      label: 'Nazwa publiczna',
      placeholder: 'Wprowadź publiczną nazwę produktu',
    },
    description: {
      label: 'Opis',
    },
  },
  buttons: {
    save: 'Zapisz',
    cancel: 'Anuluj',
  },
  feedback: {
    missing_info: 'Brakujące informacje',
  },
  toasts: {
    plan_got_created: 'Produkt został utworzony',
    plan_got_updated: 'Produkt został zaktualizowany',
  },
};
